import api from "./api";

export const projectService = {
  getAll: (filters = {}) => api.get("/projects", { params: filters }).then((res) => res.data),
  getById: (id) => api.get(`/projects/${id}`).then((res) => res.data),
  create: (data) => api.post("/projects", data).then((res) => res.data),
  update: (id, data) =>
    api.put(`/projects/${id}`, data).then((res) => res.data),
  delete: (id) => api.delete(`/projects/${id}`).then((res) => res.data),
};
